module.exports = __webpack_public_path__ + "img/west-vvip-gal-10.169d56bb.jpg";